/* eslint-disable */

import { useState, useContext } from "react";
import { Context } from "../../../App";
import { rtdb, db } from '../../../config/firebase'
import {
  getDocs,
  collection,
  query,
  where,
  orderBy,
  limit,
  arrayUnion,
  doc,
  getDoc,
  setDoc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { SiCilium } from "react-icons/si";

import { RiPushpinFill } from "react-icons/ri";


function IndividualUser({ item, setPinned, getChats }) {
  const navigate = useNavigate();
  const location = useLocation();

  const {
    groupIdContext, showUsersContext, } = useContext(Context);


  const [groupId, setGroupId] = groupIdContext;
  const [showUsers, setShowUsers] = showUsersContext;

  const [pinnedHover, setPinnedHover] = useState(false);

  return (
    <tr className={`hover:font-bold ${groupId === item.groupId ? "bg-lightPrimary" : "bg-white"}`}
      onClick={() => {
        getChats(item.groupId, item.name);
        setGroupId(item.groupId);
        if (window.innerWidth < 750) setShowUsers(false);
      }}
      onMouseEnter={() => setPinnedHover(true)}
      onMouseLeave={() => setPinnedHover(false)}
    >
      <td className="border-b border-gray-200 px-2 text-gray-800 py-1 text-xs">

        <div className="flex items-center">
          <div className="h-6 w-6 flex-shrink-0">
            <SiCilium className="h-full w-full rounded-full text-gray-600" />
          </div>
          <div className="ml-2 flex flex-col">
            <p className="whitespace-no-wrap text-xs lg:text-sm">{item.name}</p>
            <p className="text-gray-500 text-xs">{item.groupId}</p>
          </div>
        </div>
      </td>
      <td className="border-b border-gray-200 pr-1 pl-1 text-xs">
        {/* <p className="whitespace-no-wrap">Defence</p> */}
        <div className=""
          onClick={(e) => {
            e.stopPropagation()
            setPinned(item.groupId)
          }}
        >
          <RiPushpinFill className={`w-4 h-4 ${item.isPinned ? "text-headPrimary" : pinnedHover ? "text-[#cfe2f4]" : "text-white"}`} />
        </div>

      </td>

    </tr>
  )
}

export default IndividualUser